import { render } from "./Registro05Completo.vue?vue&type=template&id=2792e184"
import script from "./Registro05Completo.vue?vue&type=script&lang=js"
export * from "./Registro05Completo.vue?vue&type=script&lang=js"

import "./Registro05Completo.vue?vue&type=style&index=0&id=2792e184&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__